<script setup>
import { formatSocialRate, socialRateBarWidth } from '@/utils/socialRate';

defineProps({
  dayRate: { type: Number, default: null },
  weekRate: { type: Number, default: null },
});
</script>
<template>
  <div class="detail-row">
    <span class="detail-label">前日比</span>
    <div class="detail-bar-container">
      <div
        class="detail-bar"
        :style="{ width: `${socialRateBarWidth(dayRate)}%`, background: 'var(--accent-pink)' }"
      />
    </div>
    <span class="detail-value" style="color: var(--accent-pink);">{{ formatSocialRate(dayRate) }}</span>
  </div>
  <div class="detail-row">
    <span class="detail-label">週間</span>
    <div class="detail-bar-container">
      <div
        class="detail-bar"
        :style="{ width: `${socialRateBarWidth(weekRate)}%`, background: 'var(--accent-purple)' }"
      />
    </div>
    <span class="detail-value" style="color: var(--accent-purple);">{{ formatSocialRate(weekRate) }}</span>
  </div>
</template>
